(function() {

  'use strict';

  /**
   * Bundle Component
   * @type BundleCmpCtrl
   * @name BundleCtrl
   */
  var productItemSelectCmp = {
      bindings: {
        product: '<',
        onSelected: '&',
        onSelectedSize: '&',
        isOpenForSale: '<',
        buttonClicked: '<',
        fromShopTheLook: '<'
      },
      controller: productItemSelectCmpCtrl,
      templateUrl: 'product-item-select.component.html'
  };

  angular.module('itxApp.common')
      .component('productItemSelect', productItemSelectCmp);

  productItemSelectCmpCtrl.$inject = [
    'productPopupSvc', 
    'ItxTranslateSvc',
    'ItxScreenSizeSvc',
    'itxAkamaiSvc'
  ];

  function productItemSelectCmpCtrl(
    productPopupSvc, 
    ItxTranslateSvc,
    ItxScreenSizeSvc,
    itxAkamaiSvc
  ) {

    var _this = this;

    _this.moreColors = ItxTranslateSvc.translateCms('legacy.more_colors');
    _this.isMobile = ItxScreenSizeSvc.is('xs,sm');

    _this.$onInit = function(){
      _this.hasColors = _this.product.activeDetail.colors.length>1 && !_this.fromShopTheLook;
      _this.product.state.bundleSiluet = itxAkamaiSvc.useAkamaiProductImage(_this.product.state.bundleSiluet, 500);
    };

    _this.selectedSize = function(size){
      _this.onSelectedSize({
        size: size,
        productId: _this.product.id
      });
    };

    _this.openPopup = function () {
      if(!_this.isMobile && !_this.fromShopTheLook){
        productPopupSvc.openProductPopup(angular.copy(_this.product));
      }
    };

    _this.hasSizeSelected = function () {
      return !_this.product.state.selectedSize || _this.product.state.selectedSize && _this.product.state.selectedSize.visibility != 'show';
    };

  }

})();
